module.exports = __webpack_public_path__ + "static/media/Golden tower 14.4ff59234.webp";